<template>
  <v-row>
    <v-col cols="12" v-if="!issues.length">
      <h2 style="font-weight: 400">Add your creative messages</h2>
    </v-col>
    <v-col cols="12">
      <messages-overview-campaign-block
        v-for="(issue, index) in issues"
        :issue="issue"
        :messages="issueMessages(issue)"
        :key="index"
        @copyMessage="copyMessage"
        @openDialog="openDialog"
        @editMessage="editMessage"
      />
    </v-col>
  </v-row>
</template>

<script>
import MessagesOverviewCampaignBlock from './MessagesOverviewCampaignBlock.vue'
export default {
  name: 'messages-overview',
  components: {
    MessagesOverviewCampaignBlock
  },
  props: {
    issues: {
      type: Array,
      default: () => []
    },
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    openDialog (issue) {
      this.$emit('openDialog', issue)
    },
    issueMessages (issue) {
      return this.messages.filter(m => m.issue === issue.name)
    },
    editMessage (message) {
      this.$emit('editMessage', message)
    },
    copyMessage (message) {
      this.$emit('copyMessage', message)
    }
  }
}
</script>
